import { Col, Container, Row } from "reactstrap";
import PlansLayout from "../../layouts/PlansLayout";
import PlanCard from "../../components/Cards/PlanCard";
import { useEffect, useState } from "react";
import { API_URL } from "../../utils/constants";
import { useParams } from "react-router-dom";

function PlanCategoryPage() {
  const [plansLoading, setPlansLoading] = useState(true);
  const [plans, setPlans] = useState([]);
  const [eligibleForFreePlan, setEligibleForFreePlan] = useState(false);
  const params = useParams();  
  
  const getPlans = () => {
    setPlansLoading(true);

    fetch(API_URL+'/user/plans/'+params.id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      }
    })
    .then(response => response.json())
    .then(data => {      
      if (data.success) {
        setPlans(data.plans);
        setEligibleForFreePlan(data.eligible_for_free_plan);
      }
      setPlansLoading(false);
    })
  }

  useEffect(() => {
    getPlans();
  }, [params]);

  return(
    <PlansLayout>
      <Container className="py-4">
        {plansLoading ?
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        :
          <Row>
            {plans?.length > 0 && plans.map((data, key) => {
              return(
                <Col md="4" key={key} className="mb-3">
                  <PlanCard plan={data} eligibleForFreePlan={eligibleForFreePlan} />
                </Col>
              );
            })}
          </Row>
        }
      </Container>
    </PlansLayout>
  );
}

export default PlanCategoryPage;